import React, { useContext, useEffect, useState } from "react";

import { UserContext } from "shared/context/UserContext";
import { Accordion } from "./Accordion";
import { useFetchNavbarUserContactType } from "./hooks/useFetchNavbarUserContactType";
import { Link } from "react-router-dom";

import { UserTypes } from "shared/constants/UserTypes";

export function NavBar() {
  const user = useContext(UserContext);

  const { data } = useFetchNavbarUserContactType(user.email);

  const [userContactType, setUserContactType] = useState("");

  useEffect(() => {
    setUserContactType(data);
  }, [data]);

  return (
    <Accordion>
      <div icon="fa fa-dashboard" label=" Metric-Rx 2.0">
        <ul>
          <li key={"Analytics"}>
            <Link to="/Analytics">Dashboard</Link>
          </li>
          {/* <li key={"LocationComparison"}>
            <Link to="/LocationComparison">Benchmark</Link>
          </li>
          {userContactType == "UCT" ? (
            <li key={"AugmentedAnalytics"}>
              <Link to="/AugmentedAnalytics">Augmented Analytics</Link>
            </li>
          ) : (
            ""
          )} */}
        </ul>
      </div>
      <div icon="fa fa-building-o" label="Business Overview">
        <ul>
          <li key={"TotalSales"}>
            <Link to="/TotalSales">Total Sales / Payment Summary</Link>
          </li>
          <li key={"DSO"}>
            <Link to="/DSO">Day Sales Outstanding by Payer</Link>
          </li>
          <li key={"TPAR"}>
            <Link to="/tpar">Third Party Accounts Receivable</Link>
            {/* <Link to="#">Third Party Accounts Receivable</Link> */}
          </li>
        </ul>
      </div>
      <div icon="fa fa-hourglass-end" label="Reconciliation and Aging Manager">
        <ul>
          <li key={"RxLookup"}>
            <Link to="/RxLookup">Rx Lookup</Link>
          </li>
          <li key={"Aging"}>
            <Link to="/Aging">Aging (Outstanding) Payments</Link>
          </li>
          <li key={"PaymentExceptions"}>
            <Link to="/PaymentExceptions">Payment Exceptions</Link>
          </li>
          <li key={"PayerBinSetup"}>
            <Link to="/PayerBinSetup">Payer BIN Setup</Link>
          </li>
        </ul>
      </div>
      <div icon="fa fa-paper-plane-o" label="Remittance Administration">
        <ul>
          <li key={"RemitLookUp"}>
            <Link to="/RemitLookUp">Remittance Management</Link>
          </li>
          <li key={"MissingRemittances"}>
            <Link to="/MissingRemittances">Report a Missing Remittance</Link>
          </li>
          <li key={"835RemittanceExporting"}>
            <Link to="/835RemittanceExporting">835 Remittance Exporting</Link>
          </li>
          {/* <li key={"835ImportConversion"}>
            <Link to="/835ImportConversion">835 Import & Conversion</Link>
          </li> */}
          <li key={"ManualRemittance"}>
            <Link to="/ManualRemittance">Manual 835 Remittance Creation</Link>
          </li>
        </ul>
      </div>
      <div icon="fa fa-binoculars" label="Fee and Adjustment Tracker">
        <ul>
          <li key={"FeeAdjustment"}>
            <Link to="/FeeAdjustment">Fee and Adjustment Research</Link>
          </li>
          <li key={"CopayAdjustment"}>
            <Link to="/CopayAdjustment">Copay Adjustment Manager</Link>
          </li>
        </ul>
      </div>
      <div icon="fa fa-download" label="Report Queue">
        <ul>
          <li key={"ExcelExportDownloads"}>
            <Link to="/ExcelExportDownloads">Report Queue</Link>
          </li>
        </ul>
      </div>

      {userContactType == UserTypes.UCT ? (
        <div icon="fa fa-user" label="Admin Operations">
          <ul>
            <li key={"AdminExportBatchQueueMaintenance"}>
              <Link to="/AdminExportBatchQueueMaintenance">
                835 Export Batch Queue Maintenance
              </Link>
            </li>
            <li key={"AdminMissingRemittance"}>
              <Link to="/AdminMissingRemittance">Missing Remittance</Link>
            </li>
            {/*  <li key={"AdminPaymentMatching"}>
              <Link to="#">Payment Matching</Link>
            </li> */}
            <li key={"AdminRemittanceLookup"}>
              <Link to="/AdminRemittanceLookup"> Remittance Lookup</Link>
            </li>
            <li key={"AdminViewRestoreDeleted835"}>
              <Link to="/AdminViewRestoreDeleted835">
                View/Restore Deleted 835
              </Link>
            </li>
            <li key={"AdminRxLookup"}>
              <Link to="/AdminRxLookup">Rx Lookup</Link>
            </li>
            <li key={"AdminPaymentMatching"}>
              <Link to="/AdminPaymentMatching">Payment Matching</Link>
            </li>
            <li key={"ActivityAnalytics"}>
              <Link to="/ActivityAnalytics">Analytics</Link>
            </li>
          </ul>
        </div>
      ) : null}
    </Accordion>
  );

  // return (
  //     <Accordion>
  //         <div icon="fa fa-dashboard" label=" Metric-Rx 2.0">
  //             <ul>
  //                 <li key={"Analytics"}>
  //                     <Link to="/Analytics">Dashboard</Link>
  //                 </li>
  //                 {/* <li key={"LocationComparison"}>
  //         <Link to="/LocationComparison">Benchmark</Link>
  //       </li>
  //       {userContactType == "UCT" ? (
  //         <li key={"AugmentedAnalytics"}>
  //           <Link to="/AugmentedAnalytics">Augmented Analytics</Link>
  //         </li>
  //       ) : (
  //         ""
  //       )} */}
  //             </ul>
  //         </div>
  //         <div icon="fa fa-building-o" label="Business Overview">
  //             <ul>
  //                 <li key={"TotalSales"}>
  //                     <Link to="/TotalSales">Total Sales / Payment Summary</Link>
  //                 </li>
  //                 <li key={"DSO"}>
  //                     <Link to="/DSO">Day Sales Outstanding by Payer</Link>
  //                 </li>
  //                 <li key={"TPAR"}>
  //                     {/*  <Link to="/tpar">Third Party Accounts Receivable</Link>*/}
  //                     <Link to="#">Third Party Accounts Receivable</Link>
  //                 </li>
  //             </ul>
  //         </div>
  //         <div icon="fa fa-hourglass-end" label="Reconciliation and Aging Manager">
  //             <ul>
  //                 <li key={"RxLookup"}>
  //                     <Link to="/RxLookup">Rx Lookup</Link>
  //                 </li>
  //                 <li key={"Aging"}>
  //                     <Link to="/Aging">Aging (Outstanding) Payments</Link>
  //                 </li>
  //                 <li key={"PaymentExceptions"}>
  //                     <Link to="/PaymentExceptions">Payment Exceptions</Link>
  //                 </li>
  //             </ul>
  //         </div>
  //         <div icon="fa fa-paper-plane-o" label="Remittance Administration">
  //             <ul>
  //                 <li key={"RemitLookUp"}>
  //                     <Link to="/RemitLookUp">Remittance Management</Link>
  //                 </li>
  //                 <li key={"MissingRemittances"}>
  //                     <Link to="/MissingRemittances">Report a Missing Remittance</Link>
  //                 </li>
  //                 <li key={"835RemittanceExporting"}>
  //                     <Link to="/835RemittanceExporting">835 Remittance Exporting</Link>
  //                 </li>
  //                 <li key={"ManualRemittance"}>
  //                     <Link to="/ManualRemittance">Manual 835 Remittance Creation</Link>
  //                 </li>
  //             </ul>
  //         </div>
  //         <div icon="fa fa-binoculars" label="Fee and Adjustment Tracker">
  //             <ul>
  //                 <li key={"FeeAdjustment"}>
  //                     <Link to="/FeeAdjustment">Fee and Adjustment Research</Link>
  //                 </li>
  //                 <li key={"CopayAdjustment"}>
  //                     <Link to="/CopayAdjustment">Copay Adjustment Manager</Link>
  //                 </li>
  //             </ul>
  //         </div>
  //         <div icon="fa fa-download" label="Report Queue">
  //             <ul>
  //                 <li key={"ExcelExportDownloads"}>
  //                     <Link to="/ExcelExportDownloads">Report Queue</Link>
  //                 </li>
  //             </ul>
  //         </div>

  //         {userContactType == UserTypes.UCT ? (
  //             <div icon="fa fa-user" label="Admin Operations">
  //                 <ul>
  //                     <li key={"AdminExportBatchQueueMaintenance"}>
  //                         <Link to="/AdminExportBatchQueueMaintenance">
  //                             835 Export Batch Queue Maintenance
  //                         </Link>
  //                     </li>
  //                     <li key={"AdminMissingRemittance"}>
  //                         <Link to="/AdminMissingRemittance">Missing Remittance</Link>
  //                     </li>
  //                     {/*  <li key={"AdminPaymentMatching"}>
  //           <Link to="#">Payment Matching</Link>
  //         </li> */}
  //                     <li key={"AdminRemittanceLookup"}>
  //                         <Link to="/AdminRemittanceLookup"> Remittance Lookup</Link>
  //                     </li>
  //                     <li key={"AdminViewRestoreDeleted835"}>
  //                         <Link to="/AdminViewRestoreDeleted835">
  //                             View/Restore Deleted 835
  //                         </Link>
  //                     </li>
  //                     <li key={"AdminRxLookup"}>
  //                         <Link to="/AdminRxLookup">Rx Lookup</Link>
  //                     </li>
  //                     <li key={"AdminPaymentMatching"}>
  //                         <Link to="/AdminPaymentMatching">Payment Matching</Link>
  //                     </li>
  //                 </ul>
  //             </div>
  //         ) : null}
  //     </Accordion>
  // );
}
